<template functional>
  <section class="careers-schedule text-center">
    <div class="page-container relative">
      <h2 class="careers-schedule__title">
        Our schedule is&nbsp;flexible.
        <br />
        Our commitment to&nbsp;diversity isn&rsquo;t
      </h2>
      <p class="careers-schedule__subtitle">
        At&nbsp;Bravado, we&rsquo;re always striving to&nbsp;strengthen our commitment to&nbsp;diversity, inclusion, and
        equality. As&nbsp;a&nbsp;100% remote business with employees around the world, Bravado celebrates differences
        as&nbsp;a&nbsp;source of&nbsp;insight, creativity and unique perspective.
      </p>
    </div>
  </section>
</template>

<script lang="ts">
export default {
  name: 'CareersSchedule',
  functional: true,
};
</script>

<style lang="scss" scoped>
.careers-schedule {
  padding: 65px 0 80px;
  z-index: 1;

  @include mq('sm') {
    padding: 112px 0 40px;
  }

  &__title {
    color: #161a21;
    margin: 0 auto 16px;
    text-align: left;

    @include bravado-h4;

    @include mq('sm') {
      margin: 0 auto 32px;
      max-width: 880px;
      text-align: center;

      @include bravado-h1;
    }
  }

  &__subtitle {
    color: #19191a;
    max-width: 830px;
    margin: 0 auto 30px;
    text-align: left;

    @include body;

    @include mq('sm') {
      margin-bottom: 90px;
      text-align: center;

      @include bravado-super-headline;
    }
  }
}
</style>
